import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { PublicationService } from "../../../../services/publication.service";
import { AsyncPipe } from "@angular/common";
import { MatButton } from "@angular/material/button";
import {
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
} from "@angular/material/dialog";

@Component({
    standalone: true,
    selector: "gwo-select-publication-dialog",
    imports: [
        AsyncPipe,
        MatDialogActions,
        MatDialogClose,
        MatDialogContent,
        MatButton,
    ],
    templateUrl: "./select-publication-dialog.component.html",
    styleUrl: "./select-publication-dialog.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectPublicationDialogComponent {
    readonly publicationService = inject(PublicationService);

    readonly publications$ = this.publicationService.getPublications();
}
